import { Provider } from '@angular/core';
import { MenuProvider } from '@triggered/core';
import { AppMenuProvider } from './app-menu.provider';

export const menuProviders: Provider[] = [
  { provide: MenuProvider, useClass: AppMenuProvider, multi: true}
]
